/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gamecompanies_More1Inputs */

const ja_gamecompanies_more1 = /** @type {(inputs: Gamecompanies_More1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`and more`)
};

const en_gamecompanies_more1 = /** @type {(inputs: Gamecompanies_More1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`and more`)
};

/**
* | output |
* | --- |
* | "and more" |
*
* @param {Gamecompanies_More1Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const gamecompanies_more1 = /** @type {((inputs?: Gamecompanies_More1Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gamecompanies_More1Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_gamecompanies_more1(inputs)
	return en_gamecompanies_more1(inputs)
});
export { gamecompanies_more1 as "gameCompanies_more" }